<script setup>
import {
    defineProps,
    nextTick,
    // defineEmits,
    onMounted, ref,
    watch,
    //  computed
} from 'vue';
import Slider from '@vueform/slider'
import i18n from "@/i18n"
import { showMessage } from '@/utils/hooks/message'
import { getDashboardWeighted_ranking } from "@/service/apiList/dashboard"
import { getLangValue } from "@/utils/common"; //获取后端语言
const props = defineProps({
    title: {
        type: String,
        required: true,
        default: '数字护照：质量'
    },
    // 第一层数据
    databaseList: {
        type: Array,
        required: true,
        default: () => []
    },
    // hscodeList: {
    //     type: Array,
    //     required: true,
    //     default: () => []
    // },
    placeholder: {
        type: String,
        required: true,
        default: ''
    },
    category_id: {
        type: Number,
        required: true,
        default: 3
    },
})

// const emits = defineEmits(['search',])
// const selectedIndex = ref(0)
const type = ref([])
const hscodeList = ref([])
const selectHscode = ref('')
const hscode = ref('')
const keyword = ref('')
// const hscodeListStr = computed(() => JSON.stringify(props.hscodeList))
// const selectedHscodeList = ref()
const isToggle = ref(false)
// const rankType = ref(0) // 0 显示百分比  1显示数值
const maxValue = ref('') //存储最大值
const weightData = ref([
    // {
    //     name: 'dwqdwqdwq',
    //     value: '20%'
    // },
    // {
    //     name: 'dwqdwqdwq',
    //     value: '20%'
    // },
    // {
    //     name: 'dwqdwqdwq',
    //     value: '20%'
    // },
    // {
    //     name: 'dwqdwqdwq',
    //     value: '20%'
    // },
])
const weightList = ref(
    [
        //     {
        //         name: getLangValue('attribute.structure'),
        //         // structure: '结构',
        //         // safety: '安全',
        //         value: 0,
        //         checked: false
        //     },
        //     {
        //         name: getLangValue('attribute.safety'),
        //         value: 0,
        //         checked: false
        //     },
        //     {
        //         name: getLangValue('attribute.quality1'),
        //         value: 0,
        //         checked: false
        //     }
    ]
)
// // 获取所选 hscode 
// const getSelectedHscodeList = () => {
//     selectedHscodeList.value = props.hscodeList[selectedIndex.value].children
// }
// const changeTemplate = () => {
//     hscode.value = ''
//     weightList.value = []
//     weightData.value = []
//     if (product_template_name.value) {
//         let arr = props.databaseList.filter(item => item.name === product_template_name.value)
//         hscodeList.value = arr[0].list.map(item => {
//             return {
//                 id: item.hscode.id,
//                 title: item.hscode.title,
//             }
//         })
//     } else {
//         hscodeList.value = []
//     }
// }

const changeTemplate = () => {
    hscode.value = ''
    if (type.value.length) {
        console.log(type.value);
        let arr = props.databaseList.filter(item => item.value === type.value[0] && item.children.filter(item1 => item1.value === type.value[1]).length)
        if (arr.length) {
            // 获取shcode
            let arr1 = arr[0].children.filter(item => item.value === type.value[1])
            if (arr1.length) {
                hscodeList.value = arr1[0].database_template_list.map(item => {
                    return {
                        id: item.hscode?.id,
                        title: item.hscode?.title,
                        title_en: item.hscode?.title_en,
                    }
                })
            }
        }
    } else {
        hscodeList.value = []
    }
}
const getSum = () => {
    let arr = weightList.value.filter(item => item.checked).map(item => item.value)
    if (arr.length == 0) {
        return
    }
    // 求和
    let sum = arr.reduce((prev, cur) => prev + cur, 0)
    return sum
}

const checkForm = () => {
    // 验证表单
    if(!hscode.value) {
        showMessage('danger', getLangValue('dashboard.fillDataMessage1'))
        return
    }
    if (selectHscode.value == hscode.value) {
        if (weightList.value.length) {
            // 验证权重比例
            let arr = weightList.value.filter(item => item.checked).map(item => item.value)
            if (arr.length == 0) {
                showMessage('danger', getLangValue('dashboard.quality.message'));
                return
            }
            // 求和
            let sum = arr.reduce((prev, cur) => prev + cur, 0)
            if (sum !== 100) {
                // 权重和不对
                showMessage('danger', getLangValue('dashboard.quality.message'));
                return false
            }
            let arr1 = weightList.value.filter(item => item.checked && item.value === 0)
            // 求和
            if (arr1.length) {
                showMessage('danger', getLangValue('dashboard.quality.message1'));
                return false

            }
        }
    } else {
        weightList.value = []
        weightData.value = []
    }

    return true
}

const distributeValue = (targetValue, length) => {
    // Initialize an array of length with each value set to the base value
    let baseValue = Math.floor(targetValue / length);
    let remainder = targetValue % length;
    let result = new Array(length).fill(baseValue);

    // Distribute the remainder by adding 1 to the first few elements
    for (let i = 0; i < remainder; i++) {
        result[i] += 1;
    }

    return result;
}

const search = async () => {
    //搜索
    // emits('search', { hscode: hscode.value, keyword: keyword.value, })
    const checkRes = checkForm()
    if (!checkRes) {
        return;
    }
    let params = {
        category_id: props.category_id,
        // hscode_id: hscode.value != null && hscode.value != '' && hscode.value.length ? [...hscode.value].pop() : '',
        hscode_id: hscode.value,
        keyword: keyword.value.trim().replace('FBD', ''),
        product_template_name: type.value[0],
        index_standard_group: {},
    }
    if (weightList.value.length) {
        params.index_standard_group = weightList.value.filter(item => item.checked)
    }
    selectHscode.value = params.hscode_id
    // console.log(selectHscode.value);
    const resp = await getDashboardWeighted_ranking(params)
    // 处理返回结果
    if (resp.code == 0) {
        console.log(resp);
        if (resp.payload.length == 0) {
            showMessage('info', getLangValue('base.no_data'));
            return;
        }
        //判断
        if (weightList.value.length == 0) {
            const arr = distributeValue(100, resp.payload.length)
            weightList.value = resp.payload.map((item, index) => {
                return {
                    ...item,
                    name: item.group_name,
                    name_en: item.group_name_en,
                    value: arr[index],
                    checked: true
                }
            })
            search();
        } else {
            // 如果包含大于1的值就不需要显示
            let arr = resp.payload.filter(item => item.value > 1)
            if (arr.length) {
                // rankType.value = 1;
                // 获取最大值
                maxValue.value = Math.max(...arr.map(item => item.value))
            }
            weightData.value = resp.payload.map(item => {
                return {
                    ...item,
                    width: arr.length ? `${(item.value / maxValue.value * 100)}%` : `${item.value * 100}%`
                }
            })
        }
        // 获取高度
        nextTick(() => {
            let dom = document.querySelector('#searchBox')
            let dom1 = document.querySelector('.rank-data')
            if (dom1) {
                dom1.style.height = `calc(100% - ${dom.clientHeight}px - 1rem)`
            }
        })
    }
}

onMounted(() => {
})
watch(isToggle, () => {
    nextTick(() => {
        let dom = document.querySelector('#searchBox')
        let dom1 = document.querySelector('.rank-data')
        if (dom1) {
            dom1.style.height = `calc(100% - ${dom.clientHeight}px - 1rem)`
        }
    })
})

</script>
<template>
    <div class=" py-2" style="height: calc(100% - 1rem);">
        <div class="my-card-header">{{ props.title }}</div>
        <div class="my-card-content px-2 d-flex justify-content-between my-scroll-bar"
            style="height: calc(100% - 24px); flex-direction: column; overflow-y: auto;">
            <div style="height: auto;" id="searchBox">
                <div class="hscode my-3 search">
                    <!-- <span v-for="(item, key) in props.databaseList" :key="key" class="cursor-pointer"
                        @click="selectedIndex = key">
                        <span :class="selectedIndex == key && 'active'">{{ item.name }}</span>
                        <span class="mx-2" v-if="key < props.databaseList.length - 1">|</span>
                    </span> -->
                    <!-- <el-select @change="changeTemplate" v-model="product_template_name" filterable clearable
                        :placeholder="getLangValue('dashboard.dataBaseType')" style="width: 100%; height: 38px;">
                        <el-option v-for="item in props.databaseList" :key="item.id" :label="item.name"
                            :value="item.name" />
                    </el-select> -->
                    <el-cascader style="width: 100%; height: 38px;" v-model="type" :options="props.databaseList"
                        :placeholder="getLangValue('dashboard.dataBaseType')"
                        :props="{ label: i18n.global.locale == 'en' ? 'label_en' : 'label', }"
                        @change="changeTemplate" />
                </div>
                <!-- 搜索框 -->
                <div class="search my-2 d-flex">
                    <!-- <el-cascader placeholder="HS Code" style="width: 110px; height: 38px;"
                        :props="{ label: 'title', value: 'id' }" :show-all-levels="false" v-model="hscode"
                        :options="hscodeList" filterable clearable class="me-2" /> -->
                    <el-select v-model="hscode" filterable clearable class="me-2" placeholder="HS Code"
                        style="min-width: 110px; height: 38px;">
                        <el-option v-for="item in hscodeList" :key="item.value"
                            :label="i18n.global.locale == 'en' ? item.title_en : item.title" :value="item.id" />
                    </el-select>
                    <input clearable class="form-control" v-model="keyword" required :placeholder="placeholder" />
                </div>
                <!-- 权重占比 -->
                <div style="color: #0AB39C; font-size: 14px;" class="my-2 cursor-pointer" @click="isToggle = !isToggle">
                    {{ getLangValue('dashboard.quality.weightRatio') }} <span v-if="getSum()"
                        :class="getSum() > 100 ? 'text-danger' : ''">{{
                            getSum() }}%</span>
                    <div style="float: right;">
                        <i class=" ri-arrow-up-s-line" v-show="!isToggle"></i>
                        <i class=" ri-arrow-down-s-line" v-show="isToggle"></i>
                    </div>
                </div>
                <div class="weight-ratio my-3 pe-3" v-show="!isToggle">
                    <div v-for="(item, key) in weightList" :key="key" class="d-flex align-items-center my-3">
                        <input type="checkbox" :id="`weight-${key}`" :value="item.value" v-model="item.checked"
                            style="width: 16px; height: 16px;" />
                        <div style="width: 100px; word-break: break-all;"><label :for="`weight-${key}`"
                                class="mx-2 mb-0">{{ i18n.global.locale == 'en' ? item.name_en : item.name }}</label>
                        </div>
                        <Slider v-model="item.value" :min="0" :max="100" :showTooltip="false"
                            style="height: 2px;flex: 1;margin-right: 20px;" />
                        <el-input-number class="ms-1" style="width: 50px;" v-model="item.value" :min="1" :max="100"
                            size="small" :controls="false" controls-position="right" @change="handleChange">
                        </el-input-number>
                        <span style="font-size: 12px; margin-left: -15px; z-index: 1111;">%</span>
                        <!-- <el-slider controls-position="right" v-model="item.value" show-input size="small" :min="0" :max="100" :showTooltip="false"/> -->
                        <!-- <div style="width: 100px" class="ms-3">
                            <span v-if="item.checked">{{ getLangValue('dashboard.weight') }}:{{ item.value }}%</span>
                        </div> -->
                    </div>
                </div>

                <div class="mt-3" style="text-align: center;">
                    <button type="button" class="btn btn-success" @click="search()" style="min-width: 93px;">
                        {{ getLangValue("base.search") }}
                    </button>
                </div>
            </div>

            <!-- 数据展示 -->
            <div class="rank-data my-2 " v-if="weightData.length">
                <div class="rank-data-list my-scroll-bar d-flex flex-column " style=" overflow-y: auto; ">
                    <div class="myrank my-2" v-for="(item, key) in weightData" :key="key" :title="item.value">
                        <div class="myrank-name px-1">
                            <div class="d-flex justify-content-between align-items-center" style="font-size: 12px;">
                                {{ item.pid }}
                                <span style="font-weight: bold;">{{ item.value }}</span>
                            </div>
                        </div>
                        <!-- 如果是0的话默认展示一个像素 border-lect -->
                        <div :style="{ width: item.width }" class="myrank-bg"></div>
                    </div>
                </div>
                <div class="d-flex justify-content-between my-2">
                    <div class="ank-rate">0</div>
                    <div class="ank-rate">20%</div>
                    <div class="ank-rate">40%</div>
                    <div class="ank-rate">60%</div>
                    <div class="ank-rate">80%</div>
                    <div style="color:#2E404C">100%</div>
                </div>
            </div>
        </div>
    </div>

</template>
<style scoped lang="scss">
:deep(.el-select__placeholder.is-transparent) {
    font-size: 0.8125rem;
    color: #878a99 !important;
}

:deep(.el-select__selected-item.el-select__placeholder) {
    font-size: 0.8125rem;
    color: #212529;
}

:deep(.el-input__inner) {
    font-size: 0.8125rem;
    color: #212529;
}

// .card {
//     background-color: #495057;
//     border: 1px solid #D9D9D980;

//     .my-card-header {
//         color: white;
//         font-size: 16px;
//         font-weight: 700;
//     }

//     .my-card-content {
//         .hscode {
//             color: #9599AD;
//             word-break: break-all;

//             .active {
//                 color: white !important;
//             }
//         }

//         .search {
//             height: 38px;

//             :deep(.el-select__wrapper) {
//                 background-color: #4a5056;
//                 height: 100%;
//             }

//             :deep(.el-select__placeholder.is-transparent) {
//                 color: #889AA5 !important;
//             }

//             :deep(.el-select__selected-item) {
//                 color: white;
//             }

//             :deep(.el-input--suffix) {
//                 width: 110px;
//                 height: 100%;
//             }

//             :deep(.el-input__wrapper) {
//                 background-color: #4a5056;
//             }

//             :deep(.el-input__inner) {
//                 color: white;
//             }

//             .form-control {
//                 background-color: #4a5056;
//                 color: white;
//             }
//         }
//     }

//     .weight-ratio {
//         color: #c0c2c4;
//         font-size: 14px;

//         :deep(.slider-handle) {
//             width: 12px;
//             height: 12px;
//             background-color: #0AB39C;
//             box-shadow: unset;
//         }
//     }

//     .rank-data {

//         // flex-direction: column;
//         // flex: 1;
//         // max-height: 500px;
//         .rank-data-list {

//             // overflow-y: auto;
//             // max-height: 480px;
//             // height: calc(100% - 20px);
//             .myrank {
//                 width: 100%;
//                 position: relative;
//                 height: 20px;

//                 .myrank-name {
//                     color: #2E404C;
//                     z-index: 11;
//                     position: relative;
//                 }

//                 .myrank-bg {
//                     position: absolute;
//                     height: 100%;
//                     background-color: #0AB39CD9;
//                     top: 0;
//                 }
//             }
//         }
//     }

// }

.card1 {
    // background-color: #495057;
    border: 1px solid #D9D9D980;

    .my-card-header {
        color: #212529;
        font-size: 16px;
        font-weight: 700;
    }

    .my-card-content {
        .hscode {
            color: #9599AD;
            word-break: break-all;

            .active {
                color: white !important;
            }
        }

        .search {
            height: 38px;

            :deep(.el-select__wrapper) {
                // background-color: #4a5056;
                height: 100%;
            }

            :deep(.el-select__placeholder.is-transparent) {
                font-size: 0.8125rem;
                color: #878a99 !important;
            }

            :deep(.el-select__selected-item.el-select__placeholder) {
                font-size: 0.8125rem;
                color: #212529;
            }

            :deep(.el-cascader .el-input__inner) {
                &::placeholder {
                    font-size: 0.8125rem;
                    color: #878a99 !important;
                }
            }

            :deep(.el-input--suffix) {
                width: 110px;
                height: 100%;
            }

            :deep(.el-cascader .el-input--suffix) {
                width: 100%;
            }

            // :deep(.el-input__wrapper) {
            //     // background-color: #4a5056;
            // }

            :deep(.el-input__inner) {
                font-size: 0.8125rem;
                color: #212529;
            }

            .form-control {
                // background-color: #4a5056;
                color: #212529;
            }
        }
    }

    .weight-ratio {
        color: #212529;
        // color: #21252980;
        font-size: 14px;

        :deep(.slider-handle) {
            width: 12px;
            height: 12px;
            background-color: #0AB39C;
            box-shadow: unset;
        }

        :deep(.slider-target .slider-base) {
            color: #21252980;
        }
        :deep(.el-input-number.is-without-controls .el-input__wrapper) {
            padding-left: 2px !important
        }
    }

    .rank-data {
        flex: 1;
        border-top: 1px solid #0AB39C;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;

        .rank-rate {
            flex: 1;
            color: #212529;
        }

        // flex-direction: column;
        // flex: 1;
        // max-height: 500px;
        .rank-data-list {

            // overflow-y: auto;
            // max-height: 480px;
            // height: calc(100% - 20px);
            &:hover {
                .myrank {
                    .myrank-name {
                        display: block;
                    }
                }
            }

            .myrank {
                width: 100%;
                position: relative;
                min-height: 20px;
                border-left: 1px solid #0AB39C;
                cursor: pointer;

                // border-top: 1px dashed #0AB39C;
                &:hover {
                    box-shadow: 0 0 6px 0 #0AB39CD9;
                }

                .myrank-name {
                    color: #212529;
                    z-index: 11;
                    position: relative;
                    display: none;
                }

                .myrank-bg {
                    position: absolute;
                    height: 100%;
                    background-color: #0AB39CD9;
                    top: 0;
                }
            }
        }
    }

}
</style>